import { select } from '../helpers';

export default () => {
  const openPopupButton = select('.header .stay-up');
  const openMobilePopupButton = select('.header--mobile .stay-up');
  const closePopupButton = select('.region-stayup .region-stayup__close');
  const closeMobilePopupButton = select('.header--mobile .region-stayup .region-stayup__close');

  let menuToggledUp = false; // this should be true if menu is closed/up
  let liveChatDiv = document.getElementById('chat-widget-container');
  const menuButton = document.querySelectorAll('header button.open, header button.close-menu'); // Menu Toggles

  const openPopup = () => select('.region-stayup').classList.add('opened');
  const openMobilePopup = () => select('.header--mobile .region-stayup').classList.add('opened');
  const closePopup = () => select('.region-stayup').classList.remove('opened');
  const closeMobilePopup = () =>
    select('.header--mobile .region-stayup').classList.remove('opened');

  openPopupButton.addEventListener('click', e => {
    e.preventDefault();
    openPopup();
  });

  openMobilePopupButton.addEventListener('click', e => {
    e.preventDefault();
    openMobilePopup();
  });

  closePopupButton.addEventListener('click', closePopup);
  closeMobilePopupButton.addEventListener('click', closeMobilePopup);

  function updateLiveChatDisplay() {
    const windowWidth = window.innerWidth;
    if (!liveChatDiv) {
      // Reinitialise if liveChatDiv is not found(loaded after page load)
      liveChatDiv = document.getElementById('chat-widget-container');
    }
    // Check if window is less than 768px and menu is toggled up
    if (windowWidth < 768 && menuToggledUp) {
      if (liveChatDiv) {
        liveChatDiv.style.display = 'none';
      }
    } else if (liveChatDiv) {
      liveChatDiv.style.display = 'block';
    }
  }

  menuButton.forEach(menuButtonItem => {
    menuButtonItem.addEventListener('click', e => {
      // On change of menu, toggle menuToggledUp and call updateLiveChatDisplay
      e.preventDefault();
      menuToggledUp = !menuToggledUp;
      updateLiveChatDisplay();
    });
  });

  // Event listener for window resize
  window.addEventListener('resize', updateLiveChatDisplay);
  // Initial check
  updateLiveChatDisplay();
};
